import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './sticky-whatsapp.css';

const WHATSAPP_URL =
  'https://api.whatsapp.com/send?phone=62895339559888&text=Halo%20iTech%20Service!%20Saya%20ingin%20konsultasi%20gratis%20untuk%20perangkat%20Apple%20saya.';

const StickyWhatsApp = () => (
  <a
    href={WHATSAPP_URL}
    className="sticky-whatsapp"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Konsultasi gratis via WhatsApp"
  >
    <span className="sticky-whatsapp__icon" aria-hidden="true">
      <FontAwesomeIcon icon={faWhatsapp} />
    </span>
    <span className="sticky-whatsapp__label">Konsultasi</span>
  </a>
);

export default StickyWhatsApp;
